import shortid from "shortid";
import { formatDate } from "../../../../utils";
import { addDays } from "date-fns";
import { apiKeyDoCampo } from "./campos-veiculo";
import {
  calcularTotal,
  calculaSubtotalParaChave,
  calculoDesconto,
  totalItensListaProduto,
  totalListaServicos,
  totalPagamentos,
} from "../../add-ordem-servico/add-ordem-servico";

export class OrdemServico {
  numeroDocumento = null;
  serieDocumento = null;
  dataAbertura = null;
  dataPrevistaFechamento = null;
  dataFechamento = null;
  clienteId = null;
  clienteNome = null;
  clienteEmail = null;
  clienteCnpjCpf = null;
  clienteCep = null;
  clienteLogradouro = null;
  clienteNumero = null;
  clienteBairro = null;
  clienteCidade = null;
  clienteEstado = null;
  observacoes = "";
  observacoesChecklist = "";
  ativos = [];
  itens = [];
  servicos = [];
  pagamentos = null;
  acessorios = [];
  avarias = [];
  imagens = [];
  descontoProduto = 0;
  descontoProdutoPorcentagem = 0;
  descontoServico = 0;
  descontoServicoPorcentagem = 0;
  totalItens = 0;
  totalServicos = 0;
  totalPagamentos = 0;
  totalOrdemServico = 0;
  orcamentoServicoId = null;
  configuracaoOrdemServicoId = null;
  ativosCopiados = false;

  constructor(ordem, id) {
    if (!ordem) return;
    this.insertDadosOrdemServico(ordem, id);
  }

  insertDadosOrdemServico(ordem, id, isCopy) {
    this.ativosCopiados = !!isCopy;
    this.dataAbertura = isCopy ? new Date() : ordem.dataAbertura;
    this.dataPrevistaFechamento = !isCopy ? ordem.dataPrevistaFechamento : null;
    this.dataFechamento = !isCopy ? ordem.dataFechamento : null;
    this.status = isCopy ? "ABERTO" : ordem.status;
    this.orcamentoServicoId = ordem?.orcamentoServicoId || null;
    if (id) {
      this.createdAt = ordem.createdAt;
      this.updatedAt = ordem.updatedAt;
      this.insertUserId = ordem.insertUserId;
      this.updateUserId = ordem.updateUserId;
      this.serieDocumento = ordem.serieDocumento;
      this.numeroDocumento = ordem.numeroDocumento;
      this.statusPersonalizadoId = ordem.statusPersonalizadoId;
      this.clienteId = ordem.clienteId;
      this.clienteNome = ordem.clienteNome;
      this.clienteEmail = ordem.clienteEmail;
      this.clienteCnpjCpf = ordem.clienteCnpjCpf;
      this.clienteNumero = ordem.clienteNumero;
      this.observacoes = ordem.observacoes || "";
      this.observacoesChecklist = ordem.observacoesChecklist || "";
      this.configuracaoOrdemServicoId = ordem.configuracaoOrdemServicoId;
      this.descontoProduto = ordem.itens?.length
        ? ordem.itens.reduce((acc, curr) => acc + curr.desconto || 0, 0)
        : 0;
      this.descontoServico = ordem.servicos?.length
        ? ordem.servicos.reduce((acc, curr) => acc + curr.desconto || 0, 0)
        : 0;
      this.servicos =
        !isCopy && ordem.servicos?.length
          ? ordem.servicos.map((item) => new OrdemServicoServicos(item))
          : [];
      this.itens =
        !isCopy && ordem.itens?.length
          ? ordem.itens.map((item) => new OrdemServicoProdutos(item))
          : [];
      this.pagamentos =
        !isCopy && ordem?.pagamentos?.length
          ? ordem.pagamentos.map((pagamento) => new Pagamento(pagamento))
          : [];
      this.acessorios = Array.isArray(ordem?.acessorios)
        ? ordem.acessorios
        : [];
      this.avarias = Array.isArray(ordem?.avarias) ? ordem.avarias : [];
      this.imagens = Array.isArray(ordem?.imagens)
        ? ordem.imagens
            .map((imagem) => imagem?.url || imagem)
            .filter((imagemUrl) => !!imagemUrl)
        : [];
      if (ordem.ativos && ordem.ativos.length > 0) {
        this.ativos = ordem.ativos.map((ativoRelacao) => {
          if (ativoRelacao.ativo) {
            const ativoComValores = {
              id: ativoRelacao.ativoId,
              nome: ativoRelacao.ativo.nome,
              camposPersonalizados:
                ativoRelacao.ativo.camposPersonalizados?.map((campo) => {
                  const valorSalvo = ativoRelacao.valoresCampos?.find(
                    (v) => v.campoPersonalizadoId === campo.id,
                  );
                  return {
                    ...campo,
                    value: valorSalvo?.valor || "",
                  };
                }) || [],
            };
            return new OrdemServicoAtivos(ativoComValores);
          }
          return {
            ativoId: ativoRelacao.ativoId,
            valoresCampos: ativoRelacao.valoresCampos || [],
          };
        });
      }
    }
  }

  setStatusInicial(status) {
    this.statusInicial = status;
  }

  setOrcamentoServicoId(orcamentoServicoId) {
    this.orcamentoServicoId = orcamentoServicoId;
  }

  setConfiguracaoOrdemServicoId(configuracaoOrdemServicoId) {
    this.configuracaoOrdemServicoId = configuracaoOrdemServicoId;
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setHandleChangeDate(name, date) {
    this[name] = date != "Invalid Date" ? formatDate.toSend(date) : undefined;
  }

  setHandleChangeSwitch(name, checked) {
    this[name] = checked;
  }

  setHandleChangeAutoComplete(name, value) {
    this[name] = value ? value.id : null;
    if (name === "clienteId") {
      this.setIdentificarCliente(value);
    }
    if (name === "operacaoFiscalId") {
      this.setOperacaoFiscal(value);
    }
  }

  setIdentificarCliente(value) {
    this.clienteId = value?.id;
    this.clienteEmail = value?.email;
    this.clienteCnpjCpf = value?.cnpjCpf;
    this.clienteNome = value?.nomeRazaoSocial;
    this.clienteNumero = value?.celular;
  }

  setAtivosComValoresSalvos(ativosDisponiveis, ativosSalvos) {
    this.ativos = ativosDisponiveis.map((ativoDisponivel) => {
      const ativoSalvo = ativosSalvos?.find(
        (a) =>
          a.ativoId === ativoDisponivel.id ||
          (a instanceof OrdemServicoAtivos && a.ativoId === ativoDisponivel.id),
      );

      if (ativoSalvo) {
        if (ativoSalvo instanceof OrdemServicoAtivos) {
          return ativoSalvo;
        }

        const ativoComValores = {
          id: ativoDisponivel.id,
          nome: ativoDisponivel.nome,
          camposPersonalizados:
            ativoDisponivel.camposPersonalizados
              ?.sort((a, b) => a.ordem - b.ordem)
              .map((campo) => {
                const valorSalvo = ativoSalvo.valoresCampos?.find(
                  (v) => v.campoPersonalizadoId === campo.id,
                );
                return {
                  ...campo,
                  value: valorSalvo?.valor || "",
                };
              }) || [],
        };
        return new OrdemServicoAtivos(ativoComValores);
      }

      return new OrdemServicoAtivos({
        id: ativoDisponivel.id,
        nome: ativoDisponivel.nome,
        camposPersonalizados:
          ativoDisponivel.camposPersonalizados
            ?.sort((a, b) => a.ordem - b.ordem)
            .map((c) => ({
              ...c,
              value: "",
            })) || [],
      });
    });
  }

  setAtivos(ativosDisponiveis) {
    this.ativos = ativosDisponiveis.map(
      (ativo) =>
        new OrdemServicoAtivos({
          id: ativo.id,
          nome: ativo.nome,
          camposPersonalizados:
            ativo.camposPersonalizados
              ?.sort((a, b) => a.ordem - b.ordem)
              .map((c) => ({
                ...c,
                value: "",
              })) || [],
        }),
    );
  }

  setStatus(status) {
    this.status = status;
    if (status === "FECHADO") {
      this.dataFechamento = formatDate.toSend(new Date());
    } else {
      this.dataFechamento = null;
    }
  }

  setStatusPersonalizado(statusPersonalizadoId) {
    this.statusPersonalizadoId = statusPersonalizadoId;
  }

  atualizarValorCampoAtivo(ativoId, campoPersonalizadoId, valor) {
    const ativo = this.ativos.find((a) => a.ativoId === ativoId);
    if (ativo) {
      ativo.atualizarValorCampo(campoPersonalizadoId, valor);
    }
  }

  preencherAtivoPorPlaca(ativoId, resposta) {
    const ativo = this.ativos.find((a) => a.ativoId === ativoId);
    if (!ativo || !resposta) return;
    const dados = {
      ...(resposta.basico?.dados || {}),
      chassi:
        resposta.chassi?.dados?.chassi ?? resposta.basico?.dados?.final_chassi,
    };
    ativo.camposPersonalizados.forEach((campo) => {
      const apiKey = apiKeyDoCampo(campo);
      if (apiKey && dados[apiKey] != null) {
        ativo.atualizarValorCampo(campo.id, dados[apiKey]);
      }
    });
  }

  setChangeServicos(servicos) {
    this.servicos = servicos?.length
      ? servicos.map((servico) => new OrdemServicoServicos(servico))
      : [];

    this.descontoServico = calculaSubtotalParaChave(servicos, "", "desconto");
    this.descontoServicoPorcentagem = calculoDesconto(
      servicos,
      this,
      "descontoServico",
      "descontoServicoPorcentagem",
      false,
    );

    this.totalServicos = totalListaServicos(servicos);
    const totalServicos = totalItensListaProduto(servicos || []);
    const totalProdutos = totalItensListaProduto(this.itens || []);
    this.totalOrdemServico =
      totalProdutos -
      (this.descontoProduto || 0) +
      (totalServicos - (this.descontoServico || 0));
  }

  setEnderecoCliente(enderecoAlterado, enderecoCliente) {
    if (this.pessoaClienteId) {
      const endereco = enderecoAlterado || enderecoCliente;
      if (endereco) {
        this.orcamentoEnderecoCliente = {
          ...endereco,
          pessoaId: this.pessoaClienteId,
        };
        return;
      }
    }
    this.orcamentoEnderecoCliente = null;
  }

  setOperacaoFiscal(operacaoFiscal) {
    this.operacaoFiscalId = operacaoFiscal?.id;
    this.serieDocumento = operacaoFiscal?.serieDocumento;
    this.modeloDocumento = operacaoFiscal?.modeloDocumento;
  }

  setVendedorObrigatorioPermissao(permissao) {
    this.vendedorObrigatorio = permissao;
  }

  setConfiguracoes(configuracoes) {
    this.descontoItem = configuracoes?.descontoVendaItem;
    this.despesasItem = configuracoes?.despesaVendaItem;
    if (configuracoes?.diasVencimentoOrcamento) {
      const dataVencimento = addDays(
        new Date(),
        configuracoes?.diasVencimentoOrcamento,
      );
      this.dataVencimento = dataVencimento;
    }
  }

  setChangeItens(produtos) {
    this.itens = produtos?.length
      ? produtos.map((produto) => new OrdemServicoProdutos(produto))
      : [];
    this.totalItens = totalItensListaProduto(produtos);

    this.descontoProduto = calculaSubtotalParaChave(produtos, "", "desconto");
    this.descontoProdutoPorcentagem = calculoDesconto(
      produtos,
      this,
      "descontoProduto",
      "descontoProdutoPorcentagem",
      false,
    );
    const totalServicos = totalItensListaProduto(this.servicos || []);
    const totalProdutos = totalItensListaProduto(produtos || []);

    this.totalOrdemServico =
      totalProdutos -
      (this.descontoProduto || 0) +
      (totalServicos - (this.descontoServico || 0));
  }

  setChangePagamentos(pagamentos) {
    this.pagamentos = pagamentos?.length
      ? pagamentos.map((pagamento) => new Pagamento(pagamento))
      : [];
    this.totalPagamentos = totalPagamentos(pagamentos);
  }

  setChecklist(acessorios = [], avarias = []) {
    this.acessorios = (acessorios || []).filter(
      (acessorio) => acessorio?.contem,
    );
    this.avarias = avarias;
  }

  setImagens(imagens = []) {
    this.imagens = imagens;
  }

  setSerieDocumento(serie) {
    this.serieDocumento = serie;
  }

  initTotalPagamentos(pagamentos) {
    this.totalPagamentos = totalPagamentos(pagamentos || this.pagamentos);
    this.totalItens = totalItensListaProduto(this.itens || []);
    this.descontoProdutoPorcentagem =
      (this.descontoProduto / this.totalItens) * 100;
    this.totalServicos = totalListaServicos(this.servicos || []);
    this.descontoServicoPorcentagem =
      (this.descontoServico / this.totalServicos) * 100;
    const totalServicos = totalItensListaProduto(this.servicos || []);
    const totalProdutos = totalItensListaProduto(this.itens || []);
    this.totalOrdemServico =
      totalProdutos -
      (this.descontoProduto || 0) +
      (totalServicos - (this.descontoServico || 0));
  }
}

export class OrdemServicoAtivos {
  ativoId = null;
  nome = "";
  valoresCampos = [];
  camposPersonalizados = [];

  constructor(ativo) {
    if (ativo) {
      this.ativoId = ativo.id;
      this.nome = ativo.nome;
      this.camposPersonalizados = ativo.camposPersonalizados || [];
      this.valoresCampos =
        ativo.camposPersonalizados?.map((campo) => ({
          campoPersonalizadoId: campo.id,
          valor: campo.value || "",
          campoChave: campo.campoChave,
        })) || [];
    }
  }

  atualizarValorCampo(campoPersonalizadoId, valor) {
    const campoIndex = this.valoresCampos.findIndex(
      (campo) => campo.campoPersonalizadoId === campoPersonalizadoId,
    );

    if (campoIndex !== -1) {
      this.valoresCampos[campoIndex].valor = valor;
    } else {
      this.valoresCampos.push({
        campoPersonalizadoId,
        valor,
      });
    }
  }

  get camposParaRenderizar() {
    return this.camposPersonalizados.map((campo) => {
      const valorSalvo = this.valoresCampos.find(
        (v) => v.campoPersonalizadoId === campo.id,
      );
      return {
        ...campo,
        value: valorSalvo ? valorSalvo.valor : "",
      };
    });
  }
}

class OrdemServicoServicos {
  servicoId = null;
  prestadorServicoId = null;
  codigo = null;
  quantidade = 1;
  descricao = null;
  nome = null;
  desconto = null;
  totalItem = null;
  valor = null;
  servicoRecorrente = false;
  prazoRecorrencia = null;
  tempoAntecedencia = null;
  mensagem = null;
  anexo = null;
  classificacaoServicoNacional = null;
  codigoServicoNacional = null;
  aliquotaTotalSimplesNacional = null;

  constructor(item) {
    this.id = item.id ? item.id : shortid.generate();
    this.servicoId = item.servicoId;
    this.prestadorServicoId = item.prestadorServicoId;
    this.codigo = item.codigo;
    this.quantidade = item.quantidade;
    this.nome = item.nome;
    this.descricao = item.descricao;
    this.desconto = item.desconto;
    this.totalItem = item.quantidade * item.valor - (item.desconto || 0);
    this.valor = item.valor;
    this.servicoRecorrente = item.servicoRecorrente;
    this.prazoRecorrencia = item.prazoRecorrencia;
    this.tempoAntecedencia = item.tempoAntecedencia;
    this.classificacaoServicoNacional = item.classificacaoServicoNacional;
    this.codigoServicoNacional = item.codigoServicoNacional;
    this.aliquotaTotalSimplesNacional = item.aliquotaTotalSimplesNacional;
  }

  setMensagem(mensagem) {
    this.mensagem = mensagem;
  }

  setAnexo(anexo) {
    this.anexo = anexo;
  }
}

export class OrdemServicoProdutos {
  produtoId = null;
  descricao = null;
  unidade = null;
  quantidade = null;
  desconto = null;
  despesas = null;
  codigo = null;
  valorUnitario = null;
  ncm = null;
  tributosIcmsOrigem = null;
  origemKitId = null;
  referenciaKitId = null;
  precoCusto = null;
  ordemCompra = null;
  numeroItem = null;
  totalItem = null;
  vendedorId = null;
  insertUserId = null;
  updatedUserId = null;
  enderecoEstoqueId = null;
  produtosKit = null;

  constructor(item) {
    this.id = item.id ? item.id : shortid.generate();
    this.produtoId = item.produtoId;
    this.unidade = item.unidade;
    this.quantidade = item.quantidade;
    this.desconto = item.desconto;
    this.despesas = item.despesas;
    this.codigo = item.codigo;
    this.descricao = item.descricao;
    this.valorUnitario = item.valorUnitario;
    this.ncm = item.ncm;
    this.tributosIcmsOrigem = item.tributosIcmsOrigem;
    this.origemKitId = item.origemKitId;
    this.referenciaKitId = item.referenciaKitId;
    this.precoCusto = item.precoCusto;
    this.ordemCompra = item.ordemCompra;
    this.numeroItem = item.numeroItem;
    this.vendedorId = item.vendedorId;
    this.insertUserId = item.insertUserId;
    this.updatedUserId = item.updatedUserId;
    this.totalItem = calcularTotal(item);
    this.enderecoEstoqueId = item.enderecoEstoqueId;
    this.produtosKit = item.produtosKit;
  }

  setInputAttribute(name, value) {
    this[name] = value;
  }
}

class Pagamento {
  id = null;
  meioPagamentoId = null;
  condicaoPagamentoId = null;
  dataVencimento = null;
  valorTitulo = null;
  numeroTitulo = null;
  numeroAutorizacao = null;
  meioPagamentoSelecionado = null;
  contaReceberId = null;

  constructor(pagamento) {
    this.id = pagamento.id ? pagamento.id : shortid.generate();
    this.meioPagamentoId = pagamento.meioPagamentoId;
    this.condicaoPagamentoId = pagamento.condicaoPagamentoId;
    this.dataVencimento = pagamento.dataVencimento;
    this.valorTitulo = pagamento.valorTitulo;
    this.numeroTitulo = pagamento.numeroTitulo;
    this.numeroAutorizacao = pagamento.numeroAutorizacao;
    this.meioPagamentoSelecionado = pagamento.meioPagamentoSelecionado;
    this.contaReceberId = pagamento.contaReceberId;
  }
}
